


















import { defineComponent, ref, watch } from '@vue/composition-api';

const PanelStats = defineComponent({
  props: {
    title: { type: String },
    amount: { type: Number },
    weight: { type: String },
    active: { type: Boolean },
    icon: { type: String },
    level: { type: String, default: 'primary' },
    color: { type: String },
  },
  setup(props, { emit }) {
    return {};
  },
});

export default PanelStats;
